export default __webpack_public_path__ + "static/media/dm-01.14bd48bd.jpg";